import * as globals from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${globals.RED_400};
  font-size: 16px;
  border-radius: 4px;
  color: ${globals.white};
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 18px;
`;

export const WarningIcon: typeof Icon = styled(Icon)`
  padding: 0 8px 0 0;
  font-size: 18px;
`;
